import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import atlanta__asset from "@/assets/restore/locations/atlanta.jpg.asset.json";

const cities: StateCity[] = [
  {
    name: "Atlanta",
    serviceArea: "atlanta",
    address: "1201 Peachtree Street, Suite 200",
    img: atlanta__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=1201+Peachtree+Street+Atlanta+GA",
    to: "/locations/georgia/atlanta/",
  },
];

export const Route = createFileRoute("/locations/georgia/")({
  head: () => ({
    meta: [
      { title: "Georgia Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Georgia. Book a free personal hair loss consultation at our Atlanta location and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Georgia Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Atlanta, Georgia and book a free consultation to learn about the FUE procedure.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/georgia/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/georgia/" }],
  }),
  component: () => <StateLocationsHub stateName="Georgia" cities={cities} />,
});